import dayjs from "dayjs"
import { isMobile } from "react-device-detect"
import { IoMdClose } from "react-icons/io"
import { useSelector } from "react-redux"


const DesignImageDiv = ({ design, toggleDesignShow, selectedDesign }) => {
  const userLoggedIn = useSelector(state => state.userLoggedIn)

  return <div className=" px-1 lg:w-1/3 w-full shrink-0 h-full flex flex-col justify-evenly" onClick={() => {
    if (selectedDesign != `${design._id}${design.category}`) {
      window.scrollBy({ top: isMobile ? 200 : 400, left: 0, behavior: 'smooth' })
    }
    toggleDesignShow(design._id + design.category)
  }}>
    <div className="lg:px-4 flex flex-wrap justify-between text-sm">
      <div className=" " style={{ textShadow: " 0.2px 0.2px 0.5px #ffffff, -0.2px -0.2px 0.5px #ffffff " }}>{userLoggedIn.curator ? dayjs(new Date(design.timeStamp)).format('D MMM, YYYY') : null}</div>
      <div>Cat: {design.category}{isMobile && selectedDesign == `${design._id}${design.category}` ? <button><IoMdClose /></button> : null}</div>
    </div>
    {!isMobile || selectedDesign != `${design._id}${design.category}` ? <div className="w-full flex justify-center">
      <img src={design && design.trendingColors && design.trendingColors[design.category] && design.trendingColors[design.category].images && design.trendingColors[design.category].images[0] && design.trendingColors[design.category].images[0].imageUrl ? design.trendingColors[design.category].images[0].imageUrl :
        design && design.trendingColors && design.trendingColors[design.originalCategory] && design.trendingColors[design.originalCategory].images && design.trendingColors[design.originalCategory].images[0] && design.trendingColors[design.originalCategory].images[0].imageUrl ? design.trendingColors[design.originalCategory].images[0].imageUrl :
          design.imageUrl
      } className="max-h-96 2xl:max-h-full w-auto" />
    </div> : null}

  </div>
}

export default DesignImageDiv
